import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BMEventsType } from '../types';
import { BaseMetric, MetricState } from './base-metric';
export var WebVitalsMetric = /*#__PURE__*/function (_BaseMetric) {
  function WebVitalsMetric(_ref) {
    var _this;
    var key = _ref.key,
      route = _ref.route,
      startTime = _ref.startTime,
      stopTime = _ref.stopTime,
      pageVisibleState = _ref.pageVisibleState;
    _classCallCheck(this, WebVitalsMetric);
    _this = _callSuper(this, WebVitalsMetric, [{
      type: BMEventsType.WEB_VITALS,
      key: key
    }]);
    _this.route = route;
    _this.startTime = startTime;
    _this.stopTime = stopTime;
    _this.state = MetricState.FINISHED;
    _this.pageVisibleState = pageVisibleState;
    return _this;
  }
  _inherits(WebVitalsMetric, _BaseMetric);
  return _createClass(WebVitalsMetric);
}(BaseMetric);